/* eslint-disable-next-line @typescript-eslint/no-restricted-imports --
  Initializing i18n before the App is the only place we should import it directly.
  Use react-i18next otherwise. */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Ensure this matches LANGUAGE_COOKIE_NAME in backend/backend/settings.py
const LOOKUP_NAME = 'user_language';

const maxAge = 1 * 365 * 24 * 60 * 60; // 1 year

if (!i18n.isInitialized) {
  i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      /**
       * https://www.i18next.com/overview/configuration-options
       */
      // Ensure these match LANGUAGE_CODE and LANGUAGES in backend/backend/settings.py
      fallbackLng: 'en',
      supportedLngs: ['en', 'fr'],
      preload: ['en', 'fr'], // Preload all supported languages to avoid async loading issues, like the charity mission/description

      ns: ['common'],
      defaultNS: 'common',
      // TODO: Validate and justify why we don't escape values globally to prevent XSS attacks.
      // Could we disable it in specific scenarios instead ?
      // https://www.i18next.com/translation-function/interpolation
      interpolation: { escapeValue: false },

      /**
       * https://github.com/i18next/i18next-http-backend#backend-options
       */
      backend: {
        // Use absolute path for SSR; relative path for client.
        loadPath: '/api/v2/translations/{{lng}}/',
      },

      /**
       * https://github.com/i18next/i18next-browser-languageDetector#detector-options
       */
      detection: {
        cookieOptions: { path: '/', maxAge },
        lookupCookie: LOOKUP_NAME,
        lookupLocalStorage: LOOKUP_NAME,
        lookupSessionStorage: LOOKUP_NAME,
        // We're synchronizing with the Django backend,
        // so keep default order (which includes cookies) and enable cookie cache
        // order: [...],
        caches: ['cookie', 'localStorage'],
        // Support country language codes, ie: fr-CA -> fr
        convertDetectedLanguage: lng => lng.split('-', 1)[0],
        // TODO: Add user language preference? (when logged in)
      },
    });
}
